/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * No image server for this datasource
 * @export
 * @interface GetCharactersCharacterIdPortraitNotFound
 */
export interface GetCharactersCharacterIdPortraitNotFound {
    /**
     * error message
     * @type {string}
     * @memberof GetCharactersCharacterIdPortraitNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdPortraitNotFound interface.
 */
export function instanceOfGetCharactersCharacterIdPortraitNotFound(value: object): value is GetCharactersCharacterIdPortraitNotFound {
    return true;
}

export function GetCharactersCharacterIdPortraitNotFoundFromJSON(json: any): GetCharactersCharacterIdPortraitNotFound {
    return GetCharactersCharacterIdPortraitNotFoundFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdPortraitNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdPortraitNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCharactersCharacterIdPortraitNotFoundToJSON(json: any): GetCharactersCharacterIdPortraitNotFound {
    return GetCharactersCharacterIdPortraitNotFoundToJSONTyped(json, false);
}

export function GetCharactersCharacterIdPortraitNotFoundToJSONTyped(value?: GetCharactersCharacterIdPortraitNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

